<script setup lang="ts">
const isAuthenticated = useAuthState();
const shoutOutsStore = useShoutOutsStore();

await shoutOutsStore.fetchDiscount();
</script>

<template>
  <section v-if="shoutOutsStore.state.discount.fetchingData" class="shout-out-box">>
    <video autoplay class="tw-loading-indicator" loop muted>
      <source type="video/webm" src="/assets/images/loading-indicator/swap-2houses/128x128.webm" />
    </video>
  </section>

  <section v-else>
    <template v-if="shoutOutsStore.state.discount.percentageDiscount && shoutOutsStore.state.discount.maxSavings">
      <tw-shout-outs-discount :isAuthenticated="isAuthenticated" />
    </template>

    <template v-else>
      <tw-shout-outs-activate-subscription />
    </template>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tw-variables.scss';
@import '@/assets/styles/tw-mixins.scss';

.shout-out-box {
  @include shout-out;
}

.shout-out-box {
  padding: 1rem;
}
</style>

